export enum HsaGaleOnboardingEventKind {
  Baseline = "baseline",
  StageChanged = "stage_changed",
  CatalogSynced = "catalog_synced",
  CatalogSeeded = "catalog_seeded",
  CatalogReseeded = "catalog_reseeded",
  CatalogReviewCompleted = "catalog_review_completed",
  KycStarted = "kyc_started",
  KycApproved = "kyc_approved",
  KycActionNeeded = "kyc_action_needed",
}
